import React from "react";
import { getArmyIcon } from "../../util/getArmyIcon";

const LatestBattles = ({ lastMatches }) => {
  return (
    <div className="rounded-lg bg-gray-800 p-6 shadow-lg">
      <h2 className="mb-4 text-2xl font-semibold text-center">Latest Battles</h2>
      <div className="space-y-2 max-h-[600px] overflow-y-auto">
        {lastMatches.slice(0, 6).map((match) => {
          const ArmyIconP1 = getArmyIcon(match.army_p1);
          const ArmyIconP2 = getArmyIcon(match.army_p2);

          return (
            <div key={match.id} className="rounded-lg bg-gray-700 p-2 space-y-2">
              <div className="text-gray-400 text-center">{match.division_name} [{match.date}]</div>
              <div className="grid grid-cols-[1fr_1fr_0.5fr_0.5fr_0.5fr_1fr_1fr] items-center text-center gap-x-1">
                <div>{ArmyIconP1 && <img src={ArmyIconP1} alt="Army 1" className="w-10 h-10 mx-auto" />}</div>
                <div className="text-right text-white">
                  {match.nick1}
                  <br />
                  <p className="text-gray-500 text-sm">{match.army_p1}</p>
                </div>
                <div
                  className={`text-xl font-bold text-right ${
                    match.score_p1 > match.score_p2 ? "text-green-300" : match.score_p1 < match.score_p2 ? "text-red-300" : ""
                  }`}
                >
                  {match.score_p1}
                </div>
                <div className="text-white col-span-1 flex justify-center">vs</div>
                <div
                  className={`text-xl font-bold text-left ${
                    match.score_p2 > match.score_p1 ? "text-green-300" : match.score_p2 < match.score_p1 ? "text-red-300" : ""
                  }`}
                >
                  {match.score_p2}
                </div>
                <div className="text-left text-white">
                  {match.nick2}
                  <br />
                  <p className="text-gray-500 text-sm">{match.army_p2}</p>
                </div>
                <div>{ArmyIconP2 && <img src={ArmyIconP2} alt="Army 2" className="w-10 h-10 mx-auto" />}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LatestBattles;

